// Entry point. Put modules in ./helpers and import them here:
import marquee from './helpers/marquee.js';
import reviews from './helpers/reviews.js';
import caseStudies from './helpers/case-studies.js';

document.addEventListener('DOMContentLoaded', () => {
  marquee();
  reviews();
  caseStudies();
});
